import { useController, useFormContext } from 'react-hook-form';
import InputComponent from './component';

const RadioPicker = ({
  name,
  required = false,
  label,
  defaultValue = '',
  ...restProps
}) => {
  const { control } = useFormContext();
  const {
    field: { ref, ...inputProps },
    fieldState: { error, isTouched },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
  });

  return (
    <>
      <InputComponent
        {...inputProps}
        {...restProps}
        label={label}
        required={required}
        error={error}
        isTouched={isTouched}
        inputRef={ref}
      />
    </>
  );
};

export default RadioPicker;
